import { useLocation } from 'react-router';
import Loading from '../common/lib/Loading';
import PageNotFound from '../common/lib/PageNotFound';
import useInitialized from '../common/lib/useInitialized';
import type { MultiLang } from '../config';
import './assets/pico_main.css';
import PicoUtils from './lib/PicoUtils';
import PicoCategory from './PicoCategory';
import PicoContent from './PicoContent';
import PicoIndex from './PicoIndex';
import PicoMenu from './PicoMenu';

interface Props {
    lang: MultiLang;
    dirname: string;
}

const Pico = (props: Props) => {
    const { lang, dirname } = props;
    const { pathname, search } = useLocation();
    const context = PicoUtils.getContext(dirname);
    const status = useInitialized(context.initialize);
    if (status === null) {
        return <Loading />;
    }
    if (!status) {
        return <PageNotFound lang={lang} />;
    }
    const link = pathname.replace(new RegExp(`^${context.getModulePath()}/?`), '');
    const content = context.getContentByPath(link);
    if (content !== null) {
        return <PicoContent lang={lang} context={context} contentId={content.id} />;
    }
    const category = context.getCategoryByPath(link);
    if (category !== null) {
        return <PicoCategory lang={lang} context={context} catId={category.id} />;
    }
    if (link === '' || link === 'index.php') {
        const params = new URLSearchParams(search);
        const paramCatId = params.get('cat_id');
        if (paramCatId?.match(/^\d+$/)) {
            return <PicoCategory lang={lang} context={context} catId={parseInt(paramCatId, 10)} />;
        }
        const paramContentId = params.get('content_id');
        if (paramContentId?.match(/^\d+$/)) {
            return <PicoContent lang={lang} context={context} contentId={parseInt(paramContentId, 10)} />;
        }
        if (params.get('page') === 'menu') {
            return <PicoMenu lang={lang} context={context} />;
        }
        return <PicoIndex lang={lang} context={context} />;
    }
    return <PageNotFound lang={lang} />;
};

export default Pico;
